import React from 'react'
import { useParams } from 'react-router-dom'
import { useRedirectTo } from '@@partner:helpers/hooks/location'

import { Panel } from 'rsuite'
import LoyaltyCouponSeriesForm from '@components/marketing/loyaltyCouponSeries/LoyaltyCouponSeriesForm'

import { ROUTE_MARKETING_LOYALTY_COUPONS } from '@@partner:config/routes'

export default function LoyaltyCouponSeriesFormPage () {
  const { couponSeriesId, brandSlug } = useParams<any>()
  const redirectToList = useRedirectTo(ROUTE_MARKETING_LOYALTY_COUPONS, {
    brandSlug
  })

  return (
    <div className="LoyaltyCouponSeriesFormPage">
      <h1 className="u-heading">
        {couponSeriesId ? 'Редактирование серии купонов' : 'Добавление серии купонов'}
      </h1>
      <Panel shaded>
        <LoyaltyCouponSeriesForm 
          couponSeriesId={couponSeriesId} 
          onSaved={redirectToList} 
        />
      </Panel>
    </div>
  )
}
